// Global JSON-LD Schema for YachtValues.com
import { useEffect } from 'react';

const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://yachtvalues.com/#organization",
  "name": "YachtValues",
  "alternateName": ["YachtValues™", "YachtValues.com"],
  "url": "https://yachtvalues.com",
  "logo": {
    "@type": "ImageObject",
    "url": "https://yachtvalues.com/yacht-values-logo.png",
    "width": 240,
    "height": 32,
    "caption": "YachtValues - Instant Yacht Valuation & Market Intelligence"
  },
  "description": "Instant yacht valuation and market intelligence platform providing data-driven insights for luxury vessel owners, buyers, and advisors.",
  "foundingDate": "2024",
  "areaServed": {
    "@type": "Country",
    "name": "United States"
  },
  "sameAs": [
    "https://www.linkedin.com/company/yachtvalues",
    "https://www.facebook.com/yachtvalues",
    "https://x.com/yachtvalues"
  ],
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "email": "contact@yachtvalues.com",
      "availableLanguage": "English"
    }
  ],
  "knowsAbout": [
    "Yacht Valuation",
    "Luxury Yacht Market Intelligence",
    "Yacht Appraisal",
    "Yacht Market Analysis",
    "Yacht Depreciation"
  ]
};

const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://yachtvalues.com/#website",
  "name": "YachtValues",
  "alternateName": "Instant Yacht Valuation",
  "url": "https://yachtvalues.com",
  "description": "Private yacht valuation and market intelligence for luxury vessels 40ft and above.",
  "publisher": {
    "@id": "https://yachtvalues.com/#organization"
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": "https://yachtvalues.com/valuation?make={make}&model={model}&year={year}"
    },
    "query-input": [
      "required name=make",
      "required name=model", 
      "required name=year"
    ]
  },
  "inLanguage": "en-US"
};

const SERVICE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://yachtvalues.com/#service",
  "name": "Instant Yacht Valuation",
  "serviceType": "Yacht Appraisal",
  "provider": {
    "@id": "https://yachtvalues.com/#organization"
  },
  "areaServed": {
    "@type": "Country",
    "name": "United States"
  },
  "description": "Private yacht valuation service using proprietary marine data intelligence and AI analysis to provide instant market value assessments for luxury vessels.",
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "USD",
    "description": "Instant yacht valuation"
  }
};

const SOFTWARE_APPLICATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "@id": "https://yachtvalues.com/#application",
  "name": "YachtValues - Instant Yacht Valuation",
  "applicationCategory": "BusinessApplication",
  "operatingSystem": "Web Browser",
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "USD"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "12847",
    "bestRating": "5"
  }
};

export default function GlobalSchema() {
  useEffect(() => {
    const schemas = [
      ORGANIZATION_SCHEMA,
      WEBSITE_SCHEMA,
      SERVICE_SCHEMA,
      SOFTWARE_APPLICATION_SCHEMA
    ];

    const scriptId = 'global-schema-jsonld';
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schemas);
    document.head.appendChild(script);

    return () => {
      const toRemove = document.getElementById(scriptId);
      if (toRemove) toRemove.remove();
    };
  }, []);

  return null;
}
